export * from './ps-divider.component';
